import axios from "axios";
import qs from "qs";
import { getStore } from "../store";
import { Message, Loading } from "element-ui";
import { signatureGenerate } from "@/utils/md5";
import { setCookie } from "./common";

// 配置 baseURL,从环境变量读取(SSR 和客户端都能用到)
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL || "";
axios.defaults.timeout = 60000;

// 请求次数
let retry = 1;
/* 添加响应拦截器 */
axios.interceptors.response.use(
  function (response) {
    /* 对响应数据做些事 */
    return response;
  },
  function (error) {
    /* 请求错误时做些事 */
    // 请求超时的之后,抛出 error.code = ECONNABORTED的错误..错误信息是 timeout of  xxx ms exceeded
    if (
      error.code === "ECONNABORTED" &&
      error.message.indexOf("timeout") !== -1
    ) {
      var config = error.config;
      config.__retryCount = config.__retryCount || 0;

      if (config.__retryCount >= retry) {
        console.log(config.__retryCount, "config.__retryCount");
        return Promise.reject(error);
      }

      // Increase the retry count
      config.__retryCount += 1;

      // Create new promise to handle exponential backoff
      var backoff = new Promise(function (resolve) {
        setTimeout(function () {
          resolve();
        }, config.retryDelay || 1);
      });

      return backoff.then(function () {
        return axios(config);
      });
    } else {
      return Promise.reject(error);
    }
  },
);

export default {
  fetch(path, params, contentType) {
    Object.keys(params).forEach((key) => {
      if (params[key] === undefined) {
        params[key] = "";
      }
    });
    let dey = signatureGenerate(params);

    // Loading / Message / localStorage / document 都依赖浏览器,SSR 阶段跳过
    let loadingInstance = null;
    if (process.client) {
      loadingInstance = Loading.service({
        text: "加载中",
        background: "rgba(255,255,255,0.1)",
      });
    }
    const store = getStore();
    params.token = store.state.user.token;
    params.sign = dey.sign;
    params.timestamp = dey.timestamp;

    if (typeof FormData === "undefined" || !(params instanceof FormData)) {
      if (!contentType) {
        contentType = "application/x-www-form-urlencoded";
        params = qs.stringify({
          ...params,
        });
      }
    }
    return axios
      .post(path, params, {
        headers: {
          "Content-Type": contentType,
        },
      })
      .then(function (req) {
        let data = req.data;
        if (data.status == 200) {
          if (loadingInstance) loadingInstance.close();
        }
        if (data.status && data.status !== 200) {
          if (loadingInstance) loadingInstance.close();
          //判断token是否过期
          if (data.status == -1) {
            store.commit("USER_SIGNOUT");
            if (process.client) {
              //清除旧的token
              localStorage.clear(); //清除本地缓存
              // 清除时必须带相同 domain,否则清不掉对应作用域的 cookie
              document.cookie = `${"province"}=; Max-Age=0; path=/; domain=.gkzzd.cn`;
              document.cookie = `${"province_id"}=; Max-Age=0; path=/; domain=.gkzzd.cn`;
              setCookie("isTourist", 1, 7);
              Message({
                message: data.msg + ",即将为您跳转至登录页",
                type: "info",
              });
              setTimeout(() => {
                location.reload();
              }, 1500);
            }
          }
          if (data.status == -4) {
            if (process.client) {
              Message({
                message: "接口签名失败",
                type: "info",
              });
            }
          }
          console.log(data.message);
          return Promise.reject(data);
        }
        return data;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
};
